<app-business-partner-list [isPopup]="true" (selectedPartner)="closePopup($event)" [clientData]="data?.client" [hideGeoFenceOpt]="data?.hideGeoFenceOpt"></app-business-partner-list>
